// schema
import { logger } from "@clockwise/client-commons/src/util/logger";
import { ZonedMoment } from "@clockwise/client-commons/src/util/time-zone";
import { Event, AutopilotEventStatusEnum } from "@clockwise/schema";

export enum DefragRunFlowState {
  Unstarted = "Unstarted",
  Queued = "Queued",
  Running = "Running",
  Finished = "Finished",
}

// TODO: (nikita) these should use an enum from the server when available
export type EventAutopilotStatusCardStatus =
  | keyof typeof AutopilotEventStatusEnum
  | "OverQuota"
  | "EventExceedsDefragRange";

export const shouldRenderEventAutopilotStatus = (
  status: EventAutopilotStatusCardStatus,
): boolean => {
  const EventAutopilotStatusToRenderMap = {
    CanMove: true,
    OverQuota: true,
    Paused: true,
    EventOutsideTimeRange: true,
    EventExceedsDefragRange: true,
    Pinned: false,
    External: false,
    NoDuration: false,
    SmartHold: false,
    PrivateEvent: false,
  };

  return EventAutopilotStatusToRenderMap[status];
};

export const getEventHistoryFromEvent = (event: Event) => {
  if (
    !event.eventAutopilotHistory ||
    event.eventAutopilotHistory.__typename === "GraphEntityError"
  ) {
    logger.error("failed to get getEventHistory from event");
    return null;
  }

  return event.eventAutopilotHistory;
};

export const getDefragRunTagLabelFromMillis = (millis: number) => {
  const defragMoment = new ZonedMoment(millis);
  if (defragMoment.isBefore(new ZonedMoment())) {
    return { label: null, flowState: DefragRunFlowState.Finished };
  } else if (defragMoment.isAfter(new ZonedMoment(), "days")) {
    // returns a relative time in reference to today
    // eg. Tomorrow at.., (if next week) Monday at...
    const relativeTime = defragMoment.calendar();

    // if starts with today or tomorrow, we want to
    // render as a lowercase t but keep the AM/PM intact
    const label = relativeTime.startsWith("T")
      ? "t".concat(relativeTime.slice(1, relativeTime.length))
      : relativeTime;
    return { label, flowState: DefragRunFlowState.Unstarted };
  } else if (defragMoment.diff(new ZonedMoment(), "minutes") < 1) {
    return { label: "right now", flowState: DefragRunFlowState.Running };
  } else if (defragMoment.diff(new ZonedMoment(), "minutes") < 5) {
    return { label: "in a few minutes", flowstate: DefragRunFlowState.Queued };
  } else {
    const formattedTime = new ZonedMoment(millis).format("h:mm A");
    const label = `at ${formattedTime}`;

    return { label, flowState: DefragRunFlowState.Unstarted };
  }
};

export const getLocalDefragRunTime = (nextDefragRunMillis: number) => {
  return new ZonedMoment(nextDefragRunMillis).format("h:mm A");
};
